/*
 * @Description:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-07-31 16:11:15
 */
import Vue from 'vue';
import App from './App';
import store from './store/index.js';
import router from './router/index';
// import RouterGuide from './router/guide.js';
import pluginIndex from './plugins/index.js';
import configMethod from './config/method.js';
import './router/guide';
// import vueRegister from './public/vueRegister.js'
import { sync } from 'vuex-router-sync';
import '@/filters/index';
import * as directives from '@/directives/index';
import * as methods from '@/methods/index';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/element-variables.scss';
import './assets/css/reset.css';
import './assets/icon/iconfont.css';
import './qiankun'; // qiankun: 主文件

import Xrk from 'xrk-components';
sync(store, router);
Vue.use(Element);
Vue.use(Xrk);
// Vue.use(vueRegister)
Vue.use(pluginIndex);
Vue.prototype.$sa.init();
Vue.use(configMethod);
// Vue.use(RouterGuide)
// Vue.use(RouterGuide)

Vue.config.productionTip = false;
// Object.keys(filters).forEach(key => {
//   Vue.filter(key, filters[key])
// })
/* eslint-disable no-new */
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]);
});
Object.keys(methods).forEach(key => {
  Vue.prototype[`$${key}`] = methods[key];
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
